module.exports = __webpack_public_path__ + "static/media/YB5M07_0.5ece5187.jpg";